import { defineMessages } from 'react-intl';

export const messages: {
	tier1HelperText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tier2HelperText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tier3HelperText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	instructionsIntro: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	instructionsTier1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	instructionsTier2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	instructionsTier3: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tier1TabLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tier2TabLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tier3TabLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resetButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closePanelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetFastMedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetFastMedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetAccentureLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetAccentureDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetAllegionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetAllegionDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetAtlassianLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetAtlassianDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetCommunardoLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetCommunardoDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetRedditLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetRedditDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetProcoreLargestLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetProcoreLargestDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetHelloFreshLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetHelloFreshDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetWorkdayLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetWorkdayDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetWorkdayLargestLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetWorkdayLargestDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1PowerUserLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1PowerUserDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1EngineerICLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1EngineerICDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1DesignerICLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1DesignerICDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1ProductLeadLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1ProductLeadDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1NewContributorLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier1NewContributorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier3BrandNewLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier3BrandNewDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier3TrialLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier3TrialDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier3SoloLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	datasetTier3SoloDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentryTestSectionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentryTestSectionHelper: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentryTestButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentryBoundaryButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentryBoundaryFallbackText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentryBoundaryResetButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewToggleSectionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	switchToLoggedOutViewButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	switchToLoggedInViewButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tier1HelperText: {
		id: 'twg-microsite.debugPanel.tier1HelperText.non-final',
		defaultMessage:
			'Pick a Tier 1 dataset to preview the user-scoped view. The home page will render the user graph view seeded with the selected user-metrics payload.',
		description: 'Helper text shown above the Tier 1 dataset list in the Debug Panel',
	},
	tier2HelperText: {
		id: 'twg-microsite.debugPanel.tier2HelperText.non-final',
		defaultMessage:
			'Pick a Tier 2 dataset to preview the org-scoped view. The home page will render the org graph view seeded with the selected organisation metrics payload.',
		description: 'Helper text shown above the Tier 2 dataset list in the Debug Panel',
	},
	tier3HelperText: {
		id: 'twg-microsite.debugPanel.tier3HelperText.non-final',
		defaultMessage:
			'Pick a Tier 3 scenario to preview the getting-started view. The home page will render the capability showcase with no org metrics data.',
		description: 'Helper text shown above the Tier 3 dataset list in the Debug Panel',
	},
	title: {
		id: 'twg-microsite.debugPanel.title.non-final',
		defaultMessage: 'Data Simulation',
		description: 'Main heading for the Debug Panel',
	},
	description: {
		id: 'twg-microsite.debugPanel.description.non-final',
		defaultMessage:
			'This section allows you to simulate data for different scenarios as different organisations have verying levels of graph density and breadth.',
		description: 'Description text explaining what the Debug Panel does',
	},
	instructionsIntro: {
		id: 'twg-microsite.debugPanel.instructionsIntro.non-final',
		defaultMessage: 'Choose a tier to preview:',
		description: 'Introductory sentence before listing tier options in the Debug Panel',
	},
	instructionsTier1: {
		id: 'twg-microsite.debugPanel.instructionsTier1.non-final',
		defaultMessage: 'Tier 1 — user-scoped view seeded from a simulated user-metrics payload.',
		description: 'List item describing the Tier 1 preview in the Debug Panel instructions',
	},
	instructionsTier2: {
		id: 'twg-microsite.debugPanel.instructionsTier2.non-final',
		defaultMessage:
			'Tier 2 — org-scoped view seeded from a simulated organisation-metrics payload.',
		description: 'List item describing the Tier 2 preview in the Debug Panel instructions',
	},
	instructionsTier3: {
		id: 'twg-microsite.debugPanel.instructionsTier3.non-final',
		defaultMessage: 'Tier 3 — getting-started capability showcase for early-days tenants.',
		description: 'List item describing the Tier 3 preview in the Debug Panel instructions',
	},
	tier1TabLabel: {
		id: 'twg-microsite.debugPanel.tier1TabLabel.non-final',
		defaultMessage: 'Tier 1',
		description:
			'Tab label for Tier 1 (user-scoped) view previews in the Debug Panel tier switcher',
	},
	tier2TabLabel: {
		id: 'twg-microsite.debugPanel.tier2TabLabel.non-final',
		defaultMessage: 'Tier 2',
		description: 'Tab label for Tier 2 (org-scoped) view previews in the Debug Panel tier switcher',
	},
	tier3TabLabel: {
		id: 'twg-microsite.debugPanel.tier3TabLabel.non-final',
		defaultMessage: 'Tier 3',
		description:
			'Tab label for Tier 3 (getting started) view previews in the Debug Panel tier switcher',
	},
	resetButton: {
		id: 'twg-microsite.debugPanel.resetButton.non-final',
		defaultMessage: 'Reset',
		description: 'Button label that reloads the page and resets the Debug Panel state',
	},
	closePanelLabel: {
		id: 'twg-microsite.debugPanel.closePanelLabel.non-final',
		defaultMessage: 'Close debug panel',
		description: 'Accessibility label for the debug panel close control',
	},
	datasetFastMedLabel: {
		id: 'twg-microsite.debugPanel.dataset.fastMed.label.non-final',
		defaultMessage: 'Fast Med (no 3P)',
		description:
			'Label for the Fast Med static dataset option in the Debug Panel — a synthetic org with no third-party connectors but lots of first-party Atlassian activity, used to validate the inferred-1p-apps fallback.',
	},
	datasetFastMedDescription: {
		id: 'twg-microsite.debugPanel.dataset.fastMed.description.non-final',
		defaultMessage:
			'Healthcare org with no 3P connectors — exercises the inferred 1P apps fallback (Confluence, Jira, Loom, Bitbucket, Atlas).',
		description: 'Description for the Fast Med static dataset option in the Debug Panel',
	},
	datasetAccentureLabel: {
		id: 'twg-microsite.debugPanel.dataset.accenture.label.non-final',
		defaultMessage: 'Accenture',
		description: 'Label for the Accenture static dataset option in the Debug Panel',
	},
	datasetAccentureDescription: {
		id: 'twg-microsite.debugPanel.dataset.accenture.description.non-final',
		defaultMessage: 'Large enterprise tenant with broad Jira footprint.',
		description: 'Description for the Accenture static dataset option in the Debug Panel',
	},
	datasetAllegionLabel: {
		id: 'twg-microsite.debugPanel.dataset.allegion.label.non-final',
		defaultMessage: 'Allegion',
		description: 'Label for the Allegion static dataset option in the Debug Panel',
	},
	datasetAllegionDescription: {
		id: 'twg-microsite.debugPanel.dataset.allegion.description.non-final',
		defaultMessage: 'Mid-size tenant, low goal coverage.',
		description: 'Description for the Allegion static dataset option in the Debug Panel',
	},
	datasetAtlassianLabel: {
		id: 'twg-microsite.debugPanel.dataset.atlassian.label.non-final',
		defaultMessage: 'Atlassian',
		description: 'Label for the Atlassian static dataset option in the Debug Panel',
	},
	datasetAtlassianDescription: {
		id: 'twg-microsite.debugPanel.dataset.atlassian.description.non-final',
		defaultMessage: 'Densest internal graph; superuser of every product.',
		description: 'Description for the Atlassian static dataset option in the Debug Panel',
	},
	datasetCommunardoLabel: {
		id: 'twg-microsite.debugPanel.dataset.communardo.label.non-final',
		defaultMessage: 'Communardo',
		description: 'Label for the Communardo static dataset option in the Debug Panel',
	},
	datasetCommunardoDescription: {
		id: 'twg-microsite.debugPanel.dataset.communardo.description.non-final',
		defaultMessage: 'Smaller customer with focused activity.',
		description: 'Description for the Communardo static dataset option in the Debug Panel',
	},
	datasetRedditLabel: {
		id: 'twg-microsite.debugPanel.dataset.reddit.label.non-final',
		defaultMessage: 'Reddit',
		description: 'Label for the Reddit static dataset option in the Debug Panel',
	},
	datasetRedditDescription: {
		id: 'twg-microsite.debugPanel.dataset.reddit.description.non-final',
		defaultMessage: 'Heavy Jira usage with strong code linkage.',
		description: 'Description for the Reddit static dataset option in the Debug Panel',
	},
	datasetProcoreLargestLabel: {
		id: 'twg-microsite.debugPanel.dataset.procoreLargest.label.non-final',
		defaultMessage: 'Procore (largest)',
		description: 'Label for the largest Procore static dataset option in the Debug Panel',
	},
	datasetProcoreLargestDescription: {
		id: 'twg-microsite.debugPanel.dataset.procoreLargest.description.non-final',
		defaultMessage: 'Largest Procore tenant with rich connector activity.',
		description: 'Description for the largest Procore static dataset option in the Debug Panel',
	},
	datasetHelloFreshLabel: {
		id: 'twg-microsite.debugPanel.dataset.helloFresh.label.non-final',
		defaultMessage: 'HelloFresh',
		description: 'Label for the HelloFresh static dataset option in the Debug Panel',
	},
	datasetHelloFreshDescription: {
		id: 'twg-microsite.debugPanel.dataset.helloFresh.description.non-final',
		defaultMessage: 'Operations-heavy tenant.',
		description: 'Description for the HelloFresh static dataset option in the Debug Panel',
	},
	datasetWorkdayLabel: {
		id: 'twg-microsite.debugPanel.dataset.workday.label.non-final',
		defaultMessage: 'Workday',
		description: 'Label for the Workday static dataset option in the Debug Panel',
	},
	datasetWorkdayDescription: {
		id: 'twg-microsite.debugPanel.dataset.workday.description.non-final',
		defaultMessage: 'Mid-size tenant with very high artifact density per issue.',
		description: 'Description for the Workday static dataset option in the Debug Panel',
	},
	datasetWorkdayLargestLabel: {
		id: 'twg-microsite.debugPanel.dataset.workdayLargest.label.non-final',
		defaultMessage: 'Workday (largest)',
		description: 'Label for the largest Workday static dataset option in the Debug Panel',
	},
	datasetWorkdayLargestDescription: {
		id: 'twg-microsite.debugPanel.dataset.workdayLargest.description.non-final',
		defaultMessage: 'Largest Workday tenant with the highest artifacts-per-issue ratio.',
		description: 'Description for the largest Workday static dataset option in the Debug Panel',
	},
	datasetTier1PowerUserLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier1.powerUser.label.non-final',
		defaultMessage: 'Power user',
		description: 'Label for the Tier 1 "power user" static dataset in the Debug Panel',
	},
	datasetTier1PowerUserDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier1.powerUser.description.non-final',
		defaultMessage: 'Top of the org across pages, comments, work items, videos, and code.',
		description: 'Description for the Tier 1 "power user" static dataset in the Debug Panel',
	},
	datasetTier1EngineerICLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier1.engineerIC.label.non-final',
		defaultMessage: 'Engineer (IC)',
		description: 'Label for the Tier 1 "engineer IC" static dataset in the Debug Panel',
	},
	datasetTier1EngineerICDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier1.engineerIC.description.non-final',
		defaultMessage: 'Heavy code activity — PRs, Jira links, and GitHub events dominate.',
		description: 'Description for the Tier 1 "engineer IC" static dataset in the Debug Panel',
	},
	datasetTier1DesignerICLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier1.designerIC.label.non-final',
		defaultMessage: 'Designer (IC)',
		description: 'Label for the Tier 1 "designer IC" static dataset in the Debug Panel',
	},
	datasetTier1DesignerICDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier1.designerIC.description.non-final',
		defaultMessage: 'Design-heavy profile — strong Figma, Loom, and page activity.',
		description: 'Description for the Tier 1 "designer IC" static dataset in the Debug Panel',
	},
	datasetTier1ProductLeadLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier1.productLead.label.non-final',
		defaultMessage: 'Product lead',
		description: 'Label for the Tier 1 "product lead" static dataset in the Debug Panel',
	},
	datasetTier1ProductLeadDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier1.productLead.description.non-final',
		defaultMessage: 'Lots of pages, comments, and work items; moderate code and design.',
		description: 'Description for the Tier 1 "product lead" static dataset in the Debug Panel',
	},
	datasetTier1NewContributorLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier1.newContributor.label.non-final',
		defaultMessage: 'New contributor',
		description: 'Label for the Tier 1 "new contributor" static dataset in the Debug Panel',
	},
	datasetTier1NewContributorDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier1.newContributor.description.non-final',
		defaultMessage: 'Low volume across all surfaces but just above the Tier 1 floor.',
		description: 'Description for the Tier 1 "new contributor" static dataset in the Debug Panel',
	},
	datasetTier3BrandNewLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier3.brandNewTenant.label.non-final',
		defaultMessage: 'Brand new tenant',
		description: 'Label for the Tier 3 "brand new tenant" static dataset in the Debug Panel',
	},
	datasetTier3BrandNewDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier3.brandNewTenant.description.non-final',
		defaultMessage: 'Freshly provisioned org — nothing connected, no graph activity yet.',
		description: 'Description for the Tier 3 "brand new tenant" static dataset in the Debug Panel',
	},
	datasetTier3TrialLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier3.trialTenant.label.non-final',
		defaultMessage: 'Trial tenant',
		description: 'Label for the Tier 3 "trial tenant" static dataset in the Debug Panel',
	},
	datasetTier3TrialDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier3.trialTenant.description.non-final',
		defaultMessage: 'Evaluation tenant with a handful of seats; below the Tier 2 scale gate.',
		description: 'Description for the Tier 3 "trial tenant" static dataset in the Debug Panel',
	},
	datasetTier3SoloLabel: {
		id: 'twg-microsite.debugPanel.dataset.tier3.soloTenant.label.non-final',
		defaultMessage: 'Solo tenant',
		description: 'Label for the Tier 3 "solo tenant" static dataset in the Debug Panel',
	},
	datasetTier3SoloDescription: {
		id: 'twg-microsite.debugPanel.dataset.tier3.soloTenant.description.non-final',
		defaultMessage:
			'Single-user tenant — not enough activity to meet the Tier 2 relationships gate.',
		description: 'Description for the Tier 3 "solo tenant" static dataset in the Debug Panel',
	},
	sentryTestSectionTitle: {
		id: 'twg-microsite.debugPanel.sentryTestSectionTitle.non-final',
		defaultMessage: 'Sentry',
		description: 'Section header for the Sentry test-exception controls in the Debug Panel',
	},
	sentryTestSectionHelper: {
		id: 'twg-microsite.debugPanel.sentryTestSectionHelper.non-final',
		defaultMessage:
			'Throws a test exception and reports it to Sentry via logException. Sentry is disabled in dev environments, so events only appear in the Sentry UI on staging or production.',
		description: 'Helper text explaining what the Sentry test-exception button does',
	},
	sentryTestButtonLabel: {
		id: 'twg-microsite.debugPanel.sentryTestButtonLabel.non-final',
		defaultMessage: 'Trigger test exception',
		description: 'Label for the button that throws a test exception and reports it to Sentry',
	},
	sentryBoundaryButtonLabel: {
		id: 'twg-microsite.debugPanel.sentryBoundaryButtonLabel.non-final',
		defaultMessage: 'Throw render error (boundary)',
		description:
			'Label for the button that throws an error during render to be caught by SentryErrorBoundary',
	},
	sentryBoundaryFallbackText: {
		id: 'twg-microsite.debugPanel.sentryBoundaryFallbackText.non-final',
		defaultMessage: 'SentryErrorBoundary caught a render error and reported it.',
		description: 'Text shown in the SentryErrorBoundary fallback after a synthetic render error',
	},
	sentryBoundaryResetButtonLabel: {
		id: 'twg-microsite.debugPanel.sentryBoundaryResetButtonLabel.non-final',
		defaultMessage: 'Reset boundary',
		description: 'Label for the button that resets the SentryErrorBoundary fallback',
	},
	viewToggleSectionTitle: {
		id: 'twg-microsite.debugPanel.viewToggleSectionTitle.non-final',
		defaultMessage: 'Authentication view',
		description:
			'Helper text describing the logged-in / logged-out view toggle in the Debug Panel',
	},
	switchToLoggedOutViewButtonLabel: {
		id: 'twg-microsite.debugPanel.switchToLoggedOutViewButtonLabel.non-final',
		defaultMessage: 'Switch to logged out view',
		description:
			'Button label that forces the home page to render the logged-out (marketing) view even when the user is authenticated',
	},
	switchToLoggedInViewButtonLabel: {
		id: 'twg-microsite.debugPanel.switchToLoggedInViewButtonLabel.non-final',
		defaultMessage: 'Switch to logged in view',
		description:
			'Button label that restores the authenticated logged-in view after the debug panel forced the logged-out view',
	},
});
